import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { createStyles, makeStyles } from "@material-ui/core";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import CardInfo from "../../../components/cards/cardInfo";
import DropdownCmp from "../../../components/dropdown/DropdownCmp";
import PriceFeildComponent from "../../../components/priceFeild/priceFeildComponent";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { SALE_INVOICE_OTP, SALE_ITEM } from "../../../config/cacheKey";
import { ColumnModel } from "../../../models/common.model";
import {
  IAddSaleItemRequest,
  IGetByKeyResponse,
  IGetSaleItemGroupsResponse,
  ISaleItem,
  ISaleItemRequest,
  ISaleItemResponse,
} from "../../../models/sale.model";
import { SendOtpResponse } from "../../../models/security.model";
import {
  addSaleItem,
  cancelInvoice,
  deleteSaleItem,
  getByKey,
  getSaleItemGroups,
  sendRequestForInvoiceOtp,
} from "../../../services/sale.service";
import CancelModals from "../../../store/component/modals/modal/cancelModals";
import "./factor.css";

const columns: readonly ColumnModel[] = [
  { id: "saleItemGroupTitle", label: "گروه کالا" },
  { id: "title", label: "عنوان کالا" },
  { id: "quantity", label: "مقدار " },
  {
    id: "saleItemTotalAmount",
    label: "مبلغ کل (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
];

let muiSelected: any;
const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export default function ProformaInvoice() {
  const classes = useStyles();
  const [data, setData] = React.useState<IGetByKeyResponse>();
  const [saleItems, setSaleItems] = React.useState<ISaleItem[]>([]);
  const [responseData, setResponseData] = React.useState<ISaleItemResponse>();
  const [responseDataFactor, setResponseDataFactor] = React.useState<boolean>();
  const [totalAmount, setTotalAmount] = React.useState<number>();
  const [
    totalAmountOfSaleItemsInAlphabet,
    setTotalAmountOfSaleItemsInAlphabet,
  ] = React.useState<string>();
  const [unitTypeTitle, setUnitTypeTitle] = React.useState<string>();
  const [unitTypeId, setUnitTypeId] = React.useState<number>();
  const [itemGroups, setItemGroups] = React.useState<
    IGetSaleItemGroupsResponse[]
  >();
  const [openCancelModal, setOpenCancelModal] = useState<boolean>(false);
  const [openCancelFactorModal, setOpenCancelFactorModal] = useState<boolean>(
    false
  );
  const [productGroupId, setProductGroupId] = React.useState<number>();
  const [quantity, setQuantity] = React.useState<string>();
  const [productTitle, setProductTitle] = React.useState();
  const [unitPrice, setUnitPrice] = React.useState<any>();
  const [itemId, setItemId] = React.useState<number>();
  const [finalized, setFinalized] = React.useState<string>("");
  const history = useHistory<{
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }>();
  // let historyValue = history.location.state;
  let historyValue = JSON.parse(
    localStorage.getItem(SALE_ITEM)!
  ) as ISaleItemRequest | null;
  useEffect(() => {
    GetByKeyMutate({
      saleKey: historyValue?.saleKey!,
      branchId: historyValue?.branchId!,
      customerPersonId: historyValue?.customerPersonId!,
    });
    GetSaleItemGroupsMutate({ branchId: historyValue?.branchId! });
  }, []);
  useEffect(() => {
    if (responseDataFactor === true) {
      history.push({
        pathname: `/welcome`,
      });
    }
    if (responseData !== null && responseData !== undefined) {
      setSaleItems(responseData?.saleItems);
      setTotalAmount(responseData?.totalAmountOfSaleItems);
      setTotalAmountOfSaleItemsInAlphabet(
        responseData?.totalAmountOfSaleItemsInAlphabet
      );
    }
  }, [finalized]);
  const handleSelectedProductGroup = (e: any) => {
    e.preventDefault();
    setProductGroupId(e.target.value);
    const unitType = itemGroups?.find(
      (item: any) => item.id === e.target.value
    );
    if (unitType) {
      setUnitTypeTitle(unitType?.unitType[0]?.unitTypeTitle!);
      setUnitTypeId(Number(unitType?.unitType[0]?.id!));
    }
  };
  const handleSelectedquantity = (e: any) => {
    e.preventDefault();
    setQuantity(e.target.value);
  };
  const handleSelectedUnitPrice = (e: any) => {
    e.preventDefault();
    setUnitPrice(e.target.value);
  };
  const handleSelectedProductTitle = (e: any) => {
    e.preventDefault();
    setProductTitle(e.target.value);
  };
  const handelDetailDeleteItem = (itemId: number) => {
    setOpenCancelModal(true);
    setItemId(itemId);
  };
  const handelDetailDeleteFactor = () => {
    setOpenCancelFactorModal(true);
  };
  const handelSendRequestInvoice = () => {
    SendRequestForInvoiceOtpMutate({
      saleKey: historyValue?.saleKey!,
      customerPersonId: historyValue?.customerPersonId!,
      branchId: historyValue?.branchId!,
    });
  };
  const { mutate: GetByKeyMutate } = useMutation(getByKey, {
    onSuccess: (data: IGetByKeyResponse) => {
      if (data) {
        setData(data);
        setSaleItems(data.saleItems);
        setTotalAmount(data.saleAmount);
        setTotalAmountOfSaleItemsInAlphabet(data.saleAmountInAlphabet);
      }
    },
  });
  const { mutate: GetSaleItemGroupsMutate } = useMutation(getSaleItemGroups, {
    onSuccess: (data: IGetSaleItemGroupsResponse[]) => {
      if (data) {
        setItemGroups(data);
      }
    },
  });
  const { mutate: AddSaleItemMutate } = useMutation(addSaleItem, {
    onSuccess: (data: ISaleItemResponse) => {
      if (data) {
        setSaleItems(data.saleItems);
        setTotalAmount(data?.totalAmountOfSaleItems);
        setTotalAmountOfSaleItemsInAlphabet(
          data?.totalAmountOfSaleItemsInAlphabet
        );
        setProductGroupId(undefined);
        setProductTitle(undefined);
        setQuantity(undefined);
        setUnitPrice(undefined);
      }
    },
  });
  const { mutate: SendRequestForInvoiceOtpMutate } = useMutation(
    sendRequestForInvoiceOtp,
    {
      onSuccess: (data: SendOtpResponse) => {
        if (data) {
          localStorage.setItem(SALE_INVOICE_OTP, JSON.stringify(data));
          history.push({
            pathname: `/sale/SaleFactorOtpStep`,
            state: {
              branchId: historyValue?.branchId!,
              customerPersonId: historyValue?.customerPersonId!,
              saleKey: historyValue?.saleKey!,
            },
          });
        }
      },
    }
  );
  return (
    <>
      <div style={{ height: "100vh" }}>
        <CardInfo
          branchTitle={data?.branchTitle}
          branchAddress={data?.branchAddress}
          customerFullName={data?.customerFullName}
          customerMobileNumber={data?.customerMobileNumber}
          customerWalletAmount={data?.customerWalletAmount}
          expirationDate_Persian={data?.expirationDate_Persian}
          saleType={data?.saleType}
          saleTypeTitle={data?.saleTypeTitle}
          storeUrl={data?.storeUrl}
          storeTitle={data?.storeTitle}
        />
        <div className="pt-9" style={{ height: "70%" }}>
          <DivisionCmp
            child={
              <>
                <div
                  style={{ width: "95.5%", margin: "auto", marginTop: "1vh" }}
                >
                  <Formik
                    validateOnMount={true}
                    initialValues={{} as IAddSaleItemRequest}
                    // validationSchema={}
                    onSubmit={async (values: IAddSaleItemRequest) => {
                      values.categoryId = productGroupId!;
                      values.unitTypeId = unitTypeId!;
                      values.title = productTitle!;
                      values.quantity = Number(
                        quantity!.replace(/[۰-۹]/g, (d) =>
                          "۰۱۲۳۴۵۶۷۸۹".indexOf(d).toString()
                        )
                      );
                      values.totalPrice = Number(
                        String(unitPrice).replace(/,/g, "")
                      );
                      values.customerPersonId = historyValue?.customerPersonId!;
                      values.branchId = historyValue?.branchId!;
                      values.saleKey = historyValue?.saleKey!;
                      AddSaleItemMutate(values);
                    }}
                  >
                    {({
                      handleSubmit,
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          // columns={{ xs: 4, sm: 8, md: 12 }}
                        >
                          <Grid item xs={12} sm={6} lg={3}>
                            <DropdownCmp
                              onChange={handleSelectedProductGroup}
                              value={productGroupId ?? ""}
                              label={"گروه کالا *"}
                              options={itemGroups}
                              name="productGroupId"
                              id="productGroupId"
                              paddingRight={"15px"}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} lg={3}>
                            <MaterialTextFieldComponent
                              autoFocus={false}
                              helperText={touched.title ? errors.title : ""}
                              error={touched.title && Boolean(errors.title)}
                              placeHolder={" عنوان کالا"}
                              label={" عنوان کالا "}
                              required={true}
                              value={productTitle ?? ""}
                              onChange={handleSelectedProductTitle}
                              name="productTitle"
                              id="productTitle"
                              onBlur={handleBlur}
                              autoComplete="off"
                            />
                          </Grid>
                          <Grid item xs={12} sm={3} lg={1.5}>
                            {/* unitTypeTitle */}
                            <MaterialTextFieldComponent
                              autoFocus={false}
                              helperText={
                                touched.quantity ? errors.quantity : ""
                              }
                              error={
                                touched.quantity && Boolean(errors.quantity)
                              }
                              placeHolder={"واحد"}
                              label={"واحد"}
                              required={true}
                              value={unitTypeTitle ?? ""}
                              name="quantity"
                              id="quantity"
                              autoComplete="off"
                              disable={true}
                            />
                          </Grid>
                          <Grid item xs={12} sm={3} lg={1.5}>
                            <MaterialTextFieldComponent
                              autoFocus={false}
                              helperText={
                                touched.quantity ? errors.quantity : ""
                              }
                              error={
                                touched.quantity && Boolean(errors.quantity)
                              }
                              placeHolder={" مقدار"}
                              label={" مقدار "}
                              required={true}
                              value={quantity ?? ""}
                              onChange={handleSelectedquantity}
                              name="quantity"
                              id="quantity"
                              onBlur={handleBlur}
                              autoComplete="off"
                              onKeyDown={(event) => {
                                if (
                                  event.code === "Space" ||
                                  (!/^[0-9.]$/.test(event.key) &&
                                    event.code !== "Backspace")
                                )
                                  event.preventDefault();
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={3} lg={2}>
                            {" "}
                            <CacheProvider value={cacheRtl}>
                              <ThemeProvider theme={theme}>
                                <PriceFeildComponent
                                  helperText={
                                    touched.totalPrice ? errors.totalPrice : ""
                                  }
                                  error={
                                    touched.totalPrice &&
                                    Boolean(errors.totalPrice)
                                  }
                                  placeHolder={" مبلغ کل (ریال) *"}
                                  label={" مبلغ کل (ریال) * "}
                                  required={true}
                                  value={unitPrice ?? ""}
                                  onChange={handleSelectedUnitPrice}
                                  name="unitPrice"
                                  id="unitPrice"
                                  onBlur={handleBlur}
                                  showPersianWords={false}
                                />
                              </ThemeProvider>
                            </CacheProvider>
                          </Grid>
                          <Grid item xs={12} sm={3} lg={1}>
                            {" "}
                            <Button
                              // style={{ whiteSpace: "nowrap", width: "fit-content" }}
                              type="submit"
                              fullWidth
                              variant="contained"
                              disabled={
                                productGroupId === null ||
                                productGroupId === undefined ||
                                productTitle === null ||
                                productTitle === undefined ||
                                quantity === null ||
                                quantity === undefined ||
                                unitPrice === null ||
                                unitPrice === undefined
                                  ? true
                                  : false
                              }
                              className={
                                productGroupId === null ||
                                productGroupId === undefined ||
                                productTitle === null ||
                                productTitle === undefined ||
                                quantity === null ||
                                quantity === undefined ||
                                unitPrice === null ||
                                unitPrice === undefined
                                  ? "btnForm deactivatedButton  padding-0 "
                                  : "btnForm activatedButton padding-0 "
                              }
                            >
                              افزودن
                            </Button>
                          </Grid>
                        </Grid>
                      </form>
                    )}
                  </Formik>
                </div>
                <hr style={{ width: "96%" }} />
                <div className="cardTableBorderFactor ">
                  <TableContainer
                    style={{ background: "#fff", direction: "rtl" }}
                    // className={`${saleItems.length > 0 ? "scrollFactor" : ""}`}
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table "
                      style={{ borderCollapse: "collapse" }}
                    >
                      <TableHead
                        className="rowTHead"
                        style={{ paddingBottom: "10px" }}
                      >
                        <TableRow
                          classes={{ root: classes.select }}
                          className={`${classes} borderRight borderLeft`}
                          // selected={selectedRow === 0}
                        >
                          <TableCell
                            className="rowTHead colorTitle textFont12 fontWeight"
                            align="right"
                            style={{ width: "5px" }}
                          >
                            ردیف
                          </TableCell>
                          {columns.map((column) => (
                            <TableCell
                              className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                              key={column.id}
                              align="right"
                            >
                              {column.label}
                            </TableCell>
                          ))}
                          <TableCell
                            className="rowTHead colorTitle stickyColO"
                            align="right"
                          >
                            <MoreHorizIcon
                              scale="scale(1.8) "
                              style={{ color: "#1D4A87" }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <div style={{ width: "100%", height: "10px" }}></div>
                      {saleItems.length > 0 ? (
                        <TableBody
                          style={{
                            height: "30px",
                            minHeight: "30px",
                          }}
                        >
                          {saleItems?.map((row, rowIndex) => {
                            return (
                              <TableRow
                                classes={{ root: classes.select }}
                                className={`${
                                  rowIndex % 2 == 0
                                    ? "rowTBodyE  borderRight borderLeft"
                                    : "rowTBodyO  borderRight borderLeft"
                                }${classes} borderRight borderLeft cursorPointer noWrap`}
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                // key={row.loanRequestId}
                                // selected={selectedRow === rowIndex}
                                // onClick={() => handelDetail(row.key)}
                              >
                                <TableCell
                                  className="textFont12"
                                  style={{ width: "5px" }}
                                >
                                  {rowIndex + 1}
                                </TableCell>
                                {columns.map((column) => {
                                  const value =
                                    row[column.id as keyof ISaleItem];
                                  return (
                                    <TableCell
                                      className="textFont12 nowrapClass"
                                      key={column.id}
                                      align="right"
                                    >
                                      {column.format && column.hasFormat ? (
                                        column.format(value)
                                      ) : column.id == "status" ? (
                                        <b style={{ color: "#EE9D01" }}>
                                          {" "}
                                          {value}
                                        </b>
                                      ) : (
                                        value
                                      )}
                                    </TableCell>
                                  );
                                })}
                                <TableCell
                                  className={
                                    rowIndex % 2 == 0
                                      ? " stickyColO"
                                      : " stickyColE"
                                  }
                                >
                                  <DeleteOutlineIcon
                                    scale="scale(1.8) "
                                    className="SuccessDefaultFont"
                                    onClick={() =>
                                      handelDetailDeleteItem(row.id)
                                    }
                                  />
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      ) : null}
                    </Table>
                  </TableContainer>
                  {saleItems.length === 0 ? (
                    <>
                      {" "}
                      <span
                        className="cardEmptyTable"
                        style={{ color: "#C1C7CB", fontSize: "16px" }}
                      >
                        کالایی در پیش فاکتور ثبت نشده است.
                      </span>
                      <Grid
                        item
                        xs={1.5}
                        md={1.5}
                        sm={3}
                        style={{
                          position: "relative",
                          height: "100%",
                        }}
                        sx={{ textAlign: { xs: "center", sm: "end" } }}
                        className="paddingTop0"
                      >
                        <Button
                          type="submit"
                          onClick={() => handelDetailDeleteFactor()}
                          disabled={false}
                          className={
                            // saleItems!.length > 0 ?
                            "btn activatedErrorButton defaultHeight"
                            // : "btnForm deactivatedErrorButton Vazirmatn "
                          }
                          style={{
                            width: "200px",
                            height: "100% !important",
                            marginTop: "10px ",
                          }}
                        >
                          ابطال پیش فاکتور
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                  {saleItems.length > 0 ? (
                    <>
                      <Grid
                        container
                        alignItems={"center"}
                        style={{
                          alignItems: "center",
                          marginTop: "6vh",
                          marginBottom: "4vh",
                        }}
                        spacing={1}
                      >
                        <Grid item xs={0} sm={0} md={4}></Grid>
                        {/* <Grid item xs={4}> */}
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={4}
                          sx={{
                            marginBottom: { xs: "2vh", sm: "2v", md: "0" },
                          }}
                        >
                          <Grid container xs={12}>
                            <Grid
                              item
                              xs={12}
                              style={{
                                direction: "rtl",
                                borderRadius: "5px",
                                backgroundColor: "#F9FAFC",
                                border: "1px solid #DAE0E4",
                                height: "47px",
                                alignItems: "center",
                                display: "flex",
                                marginTop: "2vh",
                              }}
                            >
                              <Grid
                                item
                                xs={4}
                                style={{
                                  textAlign: "right",
                                  paddingRight: "2vh",
                                }}
                              >
                                <span style={{ color: "#1D4A87" }}>
                                  جمع کل (ریال):
                                </span>
                              </Grid>
                              <Grid
                                item
                                xs={8}
                                style={{ textAlign: "end", paddingLeft: "2vh" }}
                              >
                                <span
                                  style={{
                                    color: "#1D4A87",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {totalAmount?.toLocaleString()}
                                </span>
                              </Grid>
                            </Grid>
                            <Grid xs={12}>
                              <span
                                style={{
                                  color: "#1D4A87",
                                  fontSize: "12px",
                                  marginRight: "2vh",
                                  top: "1vh",
                                  position: "relative",
                                }}
                                className="fontMedium"
                              >
                                {totalAmountOfSaleItemsInAlphabet}
                              </span>
                            </Grid>
                          </Grid>
                          {/* </Grid> */}
                        </Grid>
                        {/* buttons */}
                        <Grid item xs={12} sm={12} md={4}>
                          <Grid container xs={12} spacing={1}>
                            <Grid
                              item
                              style={{
                                position: "relative",
                                textAlign: "end",
                                height: "100%",
                              }}
                              className="paddingTop0"
                              xs={12}
                              sm={8}
                              marginBottom={{ xs: "8px", sm: "unset" }}
                            >
                              <Button
                                type="submit"
                                onClick={handelSendRequestInvoice}
                                disabled={saleItems!.length > 0 ? false : true}
                                className={
                                  saleItems!.length > 0
                                    ? "btn activatedButton defaultHeight"
                                    : "btnForm deactivatedButton Vazirmatn "
                                }
                                style={{
                                  height: "47px !important",
                                  width: "100%",
                                }}
                              >
                                تایید و ثبت پیش فاکتور
                              </Button>
                            </Grid>
                            <Grid
                              item
                              style={{
                                position: "relative",
                                textAlign: "end",
                                height: "100%",
                              }}
                              className="paddingTop0"
                              xs={12}
                              sm={4}
                            >
                              <Button
                                type="submit"
                                onClick={() => handelDetailDeleteFactor()}
                                disabled={saleItems!.length > 0 ? false : true}
                                className={
                                  saleItems!.length > 0
                                    ? "btn activatedErrorButton defaultHeight"
                                    : "btnForm deactivatedErrorButton Vazirmatn "
                                }
                                style={{
                                  height: "100% !important",
                                  width: "100%",
                                }}
                              >
                                ابطال پیش فاکتور
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* end */}
                      </Grid>
                      <Grid
                        xs={12}
                        container
                        style={{
                          alignItems: "center",
                          marginTop: "1vh",
                        }}
                        spacing={1}
                        columns={{ xs: 2, sm: 8, md: 12 }}
                      >
                        <Grid item xs={4.5} md={4.5} sm={0}></Grid>
                        {/* <Grid>
                          {" "}
                          <span
                            style={{
                              color: "#1D4A87",
                              fontSize: "12px",
                              marginRight: "2vh",
                            }}
                            className="fontMedium"
                          >
                            {totalAmountOfSaleItemsInAlphabet}
                          </span>
                        </Grid> */}
                      </Grid>
                    </>
                  ) : null}
                </div>
              </>
            }
            title={"ثبت پیش فاکتور"}
            className={"mTop5"}
          ></DivisionCmp>
        </div>
        {openCancelModal && (
          <CancelModals
            setOpenCancelModal={setOpenCancelModal}
            openCancelModal={openCancelModal}
            serviceName={deleteSaleItem}
            requestModel={{
              id: itemId,
              branchId: historyValue?.branchId,
              customerPersonId: historyValue?.customerPersonId,
              saleKey: historyValue?.saleKey,
            }}
            response={"ISaleItemResponse[]"}
            setFinalized={setFinalized}
            setResponseData={setResponseData}
          />
        )}
        {openCancelFactorModal && (
          <CancelModals
            setOpenCancelModal={setOpenCancelFactorModal}
            openCancelModal={openCancelFactorModal}
            serviceName={cancelInvoice}
            requestModel={{
              branchId: historyValue?.branchId,
              customerPersonId: historyValue?.customerPersonId,
              saleKey: historyValue?.saleKey,
            }}
            response={"boolean"}
            setFinalized={setFinalized}
            setResponseData={setResponseDataFactor}
          />
        )}
      </div>
    </>
  );
}
